import { render } from "./GavLocations.vue?vue&type=template&id=77c63fdc&ts=true"
import script from "./GavLocations.vue?vue&type=script&lang=ts"
export * from "./GavLocations.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__